// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function isConstructor(value: any): boolean {
  try {
    // eslint-disable-next-line no-new,@typescript-eslint/no-unsafe-call
    new new Proxy(value, {
      construct() {
        return {};
      },
    })();
    return true;
  }
  catch (e) {
    return false;
  }
}
